
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EpbRadio',
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    checked: Boolean,
    name: String,
    disabled: Boolean,
    labelPosition: {
      type: String, // left | right
      default: 'left',
      validator: label => label === 'left' || label === 'right',
    },
  },
  emits: ['change', 'click'],
  setup(props, { emit }) {
    const baseClass = 'epb-radio'
    const classes = [
      baseClass,
      `${baseClass}--${props.labelPosition}`,
      { [`${baseClass}--disabled`]: props.disabled },
    ]

    return {
      baseClass,
      classes,
      emit,
    }
  },
})
